import { MagicConnector } from './MagicConnector';
export class MagicTestConnector extends MagicConnector {
    constructor(desiredChainId) {
        super(desiredChainId, true);
    }
}
//# sourceMappingURL=MagicTestConnector.js.map